var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "", "align-center": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "", lg2: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              items: _vm.itemsCodVehiculo,
              label: "Patente",
              "item-text": "patente_vehiculo",
              "item-value": "id",
              "return-object": ""
            },
            model: {
              value: _vm.codVehiculoSelected,
              callback: function($$v) {
                _vm.codVehiculoSelected = $$v
              },
              expression: "codVehiculoSelected"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "", lg2: "" } },
        [
          _c(
            "v-btn",
            { on: { click: _vm.onChangeFilter } },
            [_c("v-icon", [_vm._v("search")]), _vm._v("Buscar ")],
            1
          ),
          _c(
            "v-btn",
            { on: { click: _vm.clearFilters } },
            [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar ")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }